import React, { useState, useContext } from 'react';
import {
  Wrapper,
  Image,
  Title,
  Imagebox,
  ItemExternal,
  NextArrow,
  PrevArrow,
  Dot,
  Decoration
} from './WidgetPartners.style';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';
import heart from 'assets/Images/heart.svg';
import srcCrop from 'helpers/srcCrop';

function SampleNextArrow(props) {
  const { onClick } = props;
  return <NextArrow onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return <PrevArrow onClick={onClick} />;
}

function WidgetPartners({ data = [], title = '', titleColor, isActive }) {
  const [appSettings] = useContext(AppSettingsContext);
  let maxToShow = item => {
    return data.length > item
      ? appSettings.theme === 4
        ? item >= 3
          ? 3
          : item
        : item
      : data.length;
  };

  const [options] = useState({
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    arrows: appSettings.theme === 4 ? false : true,
    dots: appSettings.theme === 4 ? true : false,
    customPaging: i => <Dot theme={theme.widgetPartners.dot} />,
    infinite: true,
    speed: 2,
    slidesToShow: appSettings.theme === 4 ? 3 : 7,
    slidesToScroll: appSettings.theme === 4 ? 3 : 1,
    centerMode: true,
    speed: 500,
    slidesToShow: maxToShow(7),
    adaptiveHeight: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: maxToShow(5)
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: maxToShow(3)
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: maxToShow(1)
        }
      }
    ]
  });

  const theme = useTheme();

  const renderItem = item => {
    return (
      <>
        {item.image ? (
          <Imagebox>
            <Image
              src={srcCrop(item.image, { width: 190, height: 95, crop: false })}
              loading='lazy'
              alt={item.title}
            />
          </Imagebox>
        ) : (
          ''
        )}
      </>
    );
  };

  return (
    <Wrapper theme={theme.widgetPartners.wrapper}>
      {isActive && (
        <>
          {title && (
            <Title titleColor={titleColor} theme={theme.widgetPartners.title}>
              {title}
              {appSettings.theme === 4 ? (
                <Decoration>
                  <Image src={heart} alt='' />
                </Decoration>
              ) : (
                ''
              )}
            </Title>
          )}
          <Slider {...options}>
            {data &&
              data.map((item, key) => (
                <ItemExternal
                  key={key}
                  title={item.title}
                  href={item.slug || item.link || item.url || item.url_outside}
                  target={
                    item._blank ||
                    item.link_blank ||
                    item.url_blank ||
                    item.url_outside_blank
                      ? '_blank'
                      : '' || item.target || ''
                  }
                  rel={
                    item.nofollow ||
                    item.link_nofollow ||
                    item.url_nofollow ||
                    item.url_outside_nofollow
                      ? 'nofollow'
                      : '' || item.rel || ''
                  }
                >
                  {renderItem(item)}
                </ItemExternal>
              ))}
          </Slider>
        </>
      )}
    </Wrapper>
  );
}
export default WidgetPartners;
